enum CompanyType {
  All = 1,
  Profcoat = 2,
  VerfgroothandelHasselt = 3,
  VerfgroothandelSintTruiden = 4,
  VerfgroothandelMol = 5,
}

export default CompanyType;
